const $ = jQuery;

$(document).ready(function () {
    $('.woocommerce').on('click', 'button.quantity-change', function () {
        const input = $(this).parent('.quantity').find('input.qty');
        const value = parseInt(input.val());
        if ($(this).hasClass('quantity-plus')) {
            input.val(value + 1);
        }
        if ($(this).hasClass('quantity-minus')) {
            if (value > 1) {
                input.val(value - 1);
            }
        }
        input.change();
    });

    $('button[name="apply_coupon_side"]').click(function () {
        $('input[name="coupon_code"]').val($('input[name="coupon_code_side"]').val());
        $('button[name="apply_coupon"]').click();
    });

    $('.woocommerce').on('change', '#cover_all_fees', function () {
        $.ajax({
            method: 'POST',
            url: ajax_object.ajax_url,
            data: {
                action: 'nf_cover_fees',
                cover_fees: $(this).is(':checked') ? 1 : 0,
            },
        })
        .done(function() {
            window.location.href = window.location.href;
        });
    });

    $('.woocommerce').on('change', '#renewal_type', function () {
        $(this).attr('disabled', true);
        $.ajax({
            method: 'POST',
            url: ajax_object.ajax_url,
            data: {
                action: 'nf_subscription_renewal',
                renewal: $(this).is(':checked') ? 0 : 1,
            },
        })
        .done(function() {
            $('[name="update_cart"]').attr('disabled', false).trigger('click');
            $(this).attr('disabled', false);
        });
    });
});

// Checkout question
$(document).ready(function() {
    $('.checkout-questions input[name="checkout_question"]').change(function() {
        if ($(this).val() == 'other_answer') {
            $('input[name="other_answer"]').attr('disabled', false);
            if ($('.checkout-questions input[name="other_answer"]').val() == '') {
                $('.checkout-questions button').attr('disabled', true);
            } else {
                $('.checkout-questions button').attr('disabled', false);
            }
        } else {
            $('input[name="other_answer"]').attr('disabled', true);
            $('.checkout-questions button').attr('disabled', false);
        }
    });

    $('.checkout-questions input[name="other_answer"]').keyup(function() {
        if ($('.checkout-questions input[name="checkout_question"]:checked').val() == 'other_answer') {
            if ($(this).val() == '') {
                $('.checkout-questions button').attr('disabled', true);
            } else {
                $('.checkout-questions button').attr('disabled', false);
            }
        }
    });

    $('.checkout-questions button').click(function(e) {
        e.preventDefault();
        $(this).attr('disabled', true);
        const answer = $('.checkout-questions input[name="checkout_question"]:checked').val() == 'other_answer' ?
            $('.checkout-questions input[name="other_answer"]').val() :
            $('.checkout-questions input[name="checkout_question"]:checked').val();
        $.ajax({
            method: 'POST',
            url: ajax_object.ajax_url,
            data: {
                action: 'snack_checkout_question',
                order_id: $('.checkout-questions input[name="checkout_question_order_id"]').val(),
                answer,
            },
        })
        .done(function() {
            $('.checkout-questions .checkout-question-container').addClass('hidden');
            $('.checkout-questions .checkout-question-confirmation').removeClass('hidden');
            $(this).attr('disabled', false);
            document.querySelector('.section-checkout').scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});

const check2Pack = () => {
    if ($('select[name="attribute_pa_amount"]').length === 0) {
        return;
    }

    const val = $('select[name="attribute_pa_amount"]').val();
    if (val.indexOf('2-pack-1-5-oz') === 0 || val.indexOf('5-pack') === 0) {
        setTimeout(function() {
            $('input[name="subscribe-to-action-input"][value="no"]').attr('checked', 'checked').trigger('change');
            $('.wcsatt-options-prompt-label-subscription').hide();
        }, 100);
    } else {
        $('.wcsatt-options-prompt-label-subscription').show();
    }
}

$('.variations_form').on('woocommerce_variation_select_change', function() {
    check2Pack();
});

$(document).ready(function() {
    if ($('.variations_form').length > 0) {
        setTimeout(function() {
            check2Pack();
        }, 100);
    }
});



// WEBPACK FOOTER //
// ./src/js/shop.js